<template>
    <Page :type="(screenSize!='xs') ? 'white' : 'gray'" :header="(screenSize=='xs') ? '' : content[lang].title" :nopadding="true">
        <template v-slot:body>
            <div class="w-full flex flex-column gap-3">
                <div v-if="cardData" class="w-full flex flex-column max-w-30rem
                    gap-3 xl:gap-4 lg:gap-3 md:gap-3 sm:gap-3
                    py-5 xl:py-6 lg:py-5 md:py-5 sm:py-5">

                    <div class="w-full flex flex-column gap-3 align-items-center xl:align-items-start lg:align-items-start md:align-items-start sm:align-items-start">
                        <span class="flex text-600">{{ content[lang].wallet_balance }}</span>
                        <div v-if="vcardBalance" class="flex flex-row gap-2 white-space-nowrap align-items-center mb-3">
                            <span class="flex text-700 text-5xl font-medium">{{ get_format_amount(vcardBalance) }} </span>
                            <span class="flex text-600 text-lg font-medium">USDT</span>
                        </div>
                    </div>

                    <div class="w-full flex flex-column gap-3 
                        p-4 xl:p-0 lg:p-0 md:p-0 sm:p-0">
                        <div class="w-full flex">
                            <div class="w-full flex flex-column flex-1 align-items-start border-none border-green-300
                                p-3 xl:p-4 lg:p-4 md:p-4
                                border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl border-ios-2xl"
                                :style="{ background: getBackground(cardData) }">

                                <div v-if="!sensitive" class="w-full flex flex-row gap-3 relative">
                                    <div class="w-full" style="padding-bottom:58%"></div>

                                    <div v-if="cardData.title && cardData.last4" :style="{ color: getColor(cardData) }"
                                        class="absolute top-0 left-0 flex flex-column gap-1">
                                        <span class="flex text-sm font-medium mb-3">
                                            {{ cardData.title }}
                                        </span>
                                        <span v-if="cardData && getCountry(cardData)" class="flex text-xs font-medium mb-3">
                                            {{ content[lang].country }}: {{ getCountry(cardData) }}
                                        </span>
                                    </div>
                                    

                                    <div v-if="cardData.brand" :style="{ color: getColor(cardData) }"
                                        class="absolute bottom-0 right-0">
                                        <span class="flex text-lg font-bold">
                                            {{ cardData.brand }}
                                        </span>
                                    </div>

                                    <div v-if="cardData.last4" :style="{ color: getColor(cardData) }"
                                        class="absolute bottom-0 left-0">
                                        <span class="flex text-xl font-medium">
                                            ..{{ cardData.last4 }}
                                        </span>
                                    </div>
                                </div>

                                <div v-else class="w-full flex flex-column flex-1 gap-3 relative">
                                    <div class="w-full" style="padding-bottom:55%"></div>

                                    <div class="absolute top-0 left-0 flex flex-column flex-1 align-items-startp-2 border-round-lg"
                                        :style="{ color: getColor(cardData) }">
                                        <span class="flex mb-2 text-xs font-medium">
                                            {{ content[lang].cardNumber }}
                                        </span>
                                        <span v-if="cardData.card_number" class="flex text-sm font-medium">
                                            {{ formatCard(cardData.card_number) }} <i class="pi pi-copy text-700 text-sm ml-2" @click="copy(cardData.card_number)" />
                                        </span>
                                    </div>

                                    <div class="absolute bottom-0 right-0 flex flex-column flex-1 align-items-startp-2 border-round-lg"
                                        :style="{ color: getColor(cardData) }">
                                        <span class="flex mb-2 text-xs font-medium">
                                            {{ content[lang].expirationDate }}
                                        </span>
                                        <span v-if="cardData.expiration_date_short" class="flex text-sm font-medium">
                                            {{ cardData.expiration_date_short }} <i class="pi pi-copy text-sm ml-2" @click="copy(cardData.expiration_date_short)" />
                                        </span>
                                    </div>

                                    <div class="absolute bottom-0 left-0 flex flex-column flex-1 align-items-startp-2 border-round-lg"
                                        :style="{ color: getColor(cardData) }">
                                        <span class="flex mb-2 text-xs font-medium">
                                            {{ content[lang].cvv }}
                                        </span>
                                        <span v-if="cardData.cvv" class="flex text-sm font-medium">
                                            {{ cardData.cvv }} <i class="pi pi-copy text-sm ml-2" @click="copy(cardData.cvv)" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-full flex">
                            <div class="w-full flex flex-column flex-1 gap-3 align-items-start border-none surface-0
                                p-3 xl:p-4 lg:p-4 md:p-4
                                border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl border-ios-2xl">
                                <span class="flex text-xs font-medium">
                                   {{ content[lang].card_balance }}
                                </span>
                                <span v-if="(cardData.balance!=undefined && cardData.currency_code)" 
                                    class="block text-4xl font-medium white-space-nowrap">
                                    {{ get_format_amount(cardData.balance, cardData.currency_code) }}
                                </span>
                                <Message v-if="cardData && (cardData.active==false)" severity="warn" class="border-round-xl mb-2" icon="pi pi-exclamation-triangle">
                                    <span class="line-height-2 text-sm xl:text-md lg:text-sm">{{  content[lang].notActive }}</span>
                                </Message>
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex">
                    
                        <div v-if="!loading" class="w-full align-items-center flex flex-row gap-3 max-w-30rem mt-3 mb-6
                            justify-content-center xl:justify-content-start lg:justify-content-start md:justify-content-start sm:justify-content-start">

                            <div class="flex flex-column align-items-center justify-content-center mx-1">
                                <Button @click="getSensitive" rounded severity="primary" size="large" class="mb-2 border-none" 
                                    :icon="(sensitive) ? 'pi pi-eye-slash' : 'pi pi-eye'"
                                    :class="(sensitive) ? 'bg-green-500 text-green-100' : ''"/>
                                <span class="text-xs text-500 font-medium">{{ content[lang].fieldsBtn }}</span>
                            </div>

                            <div class="flex flex-column align-items-center justify-content-center mx-1">
                                <Button @click="displayPopupTopup=true" rounded :disabled="!canTopup"
                                    icon="pi pi-arrow-down" severity="primary" size="large" class="mb-2 border-none" />
                                <span class="text-xs text-500 font-medium">{{ content[lang].topupBtn }}</span>
                            </div>

                            <!-- <div class="flex flex-column align-items-center justify-content-center mx-1">
                                <Button  rounded icon="pi pi-wallet" size="large" 
                                    class="mb-2 border-none" severity="secondary" :disabled="true"/>
                                <span class="text-xs text-500 font-medium">{{ content[lang].freezeBtn }}</span>
                            </div> -->
                        </div>
                    </div>

                    <!--Transactions-->
                    <div v-if="!loading && cardData && cardData.transactions && cardData.transactions.length>0" 
                        class="w-full mb-5 px-3 xl:px-0 lg:px-0 md:px-0">
                        <div class="w-full flex flex-row mb-3">
                            <div class="flex flex-1 align-items-center">
                                <span class="text-xl font-medium text-900">{{ content[lang].transactions }}</span>
                            </div>
                            <div class="flex">
                                <Button :label="content[lang].transactionsBtn" @click="toTransactions()" size="small" severity="secondary"
                                    class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                            </div>
                        </div>
                        <div class="w-full flex">
                            <Transactions :transactions="cardData.transactions" :loading="loading" 
                                :total="4" 
                                :limit="4"
                                :skip="0" />
                        </div>
                    </div>
                    
                </div>
                <div v-else class="w-full p-3">
                    <Skeleton height="2rem" class="mb-3"/> 
                    <Skeleton height="8rem" class="mb-3 border-round-xl"/> 
                </div>
            </div>
        </template>
    </Page>

    <Dialog class="w-full border-none border-round-xl" modal 
        v-model:visible="displayPopupTopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].topupTitle }}</span>
        </template>

        <div class="field mt-2 mb-3 flex flex-column gap-3">
            <span class="flex text-color-secondary">
                {{ content[lang].sum }}
            </span>
            <div class='flex w-full'>
                <IconField iconPosition="right" class="w-full">
                    <InputNumber v-model="amount" aria-describedby="iban_number-help" :useGrouping="false" :showButtons="true"
                        class="w-full border-2 border-round-xl surface-border overflow-hidden amount_input" size="large"
                        :min="minAmount" :max="maxAmount" :step="1" />
                </IconField>
            </div>
            <span class="flex text-600 text-xs font-medium">
                {{ content[lang].debitAmount }}: {{ get_format_amount(fullamount, 'usdt') }}
            </span>
            <span class="flex text-600 text-xs font-medium">
                {{ content[lang].coms }}: {{ getPercentage(comissionPercent) }}%
            </span>
        </div>

        <template #footer>
            <div class="field w-full">
                <Button @click="topup()"
                    :label="content[lang].topupBtn" 
                    class="p-button-lg w-full border-round-lg" 
                    :loading="loading_" :disabled="loading_ || !canTopup" />
            </div>
        </template>
    </Dialog>

</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import Transactions from    '@/components/personal/Transactions.vue'
import { mapActions } from  'vuex'
import { useRoute } from    'vue-router'
import BigNumber from 'bignumber.js'
import CardsTemplate from   '@/assets/json/vcards.json'

export default {
    data() {
        return {
            maxTopupAmount: 1000,
            content: {
                ru: {
                    title: 'Карта',
                    wallet_balance: 'Баланс счета',
                    card_balance: 'Баланс карты',
                    fieldsBtn: 'Реквизиты',
                    topupBtn: 'Пополнить',
                    freezeBtn: 'Заморозить',
                    cardNumber: 'Номер карты',
                    expirationDate: 'Дата истечения',
                    notActive: 'Карта неактивна',
                    cvv: 'CVV',
                    country: 'Страна',
                    topupTitle: 'Пополнить карту',
                    sum: 'Сумма',
                    amount: 'Сумма зачисления',
                    debitAmount: 'Сумма списания',
                    coms: 'Комиссия',
                    topupLabel: 'Пополнить',
                    copied: 'Скопировано',
                    transactions: 'Транзакции',
                    transactionsBtn: 'Все транзакции',
                },
                en: {
                    title: 'Card',
                    wallet_balance: 'Account balance',
                    card_balance: 'Card balance',
                    fieldsBtn: 'Fields',
                    topupBtn: 'Topup',
                    freezeBtn: 'Freeze',
                    cardNumber: 'Card number',
                    expirationDate: 'Expiration date',
                    cvv: 'CVV',
                    country: 'Country',
                    topupTitle: 'Topup card',
                    notActive: 'Card is not active',
                    sum: 'Sum',
                    amount: 'Amount',
                    debitAmount: 'Debited amount',
                    coms: 'Comission',
                    topupLabel: 'Topup',
                    copied: 'Copied',
                    transactions: 'Transactions',
                    transactionsBtn: 'All transactions',
                }
            },
            loading: true,
            card_id: null,
            cardData: null,
            sensitive: 0,
            displayPopupTopup: false,
            loading_: false,
            amount: 0,
            maxAmount: 0,
            minAmount: 1,
            fullamount: 0,
            comissionPercent: 0.05,
            cardsTemplate: CardsTemplate
        }
    },
    components: {
        Page,
        Transactions
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        vcardBalance() { return this.$store.getters.StateVcardBalance },
        canTopup() { 
            if(!this.cardData || !this.cardData.active) return false
            if (!this.amount || this.amount <= 0) return false
            const bAmount = new BigNumber(this.amount)
            const bFullAmount = new BigNumber(this.fullamount)
            const bVcardBalance = new BigNumber(this.vcardBalance || 0)

            return bAmount.isGreaterThan(0)
                && bAmount.isLessThanOrEqualTo(this.maxAmount)
                && bFullAmount.isLessThanOrEqualTo(bVcardBalance)
        },
    },
    watch: {
        amount: {
            handler: function (val) {
                this.fullamount = this.getDebitAmount(val).toNumber()
            },
            immediate: true
        },
        vcardBalance: {
            handler: function (val) {
                let maxAmount = this.getCreditAmountByBalance(val)
                if (maxAmount.isGreaterThan(this.maxTopupAmount)) maxAmount = new BigNumber(this.maxTopupAmount)
                this.maxAmount = maxAmount.toNumber()

                const currentAmount = new BigNumber(this.amount || 0)
                if (!currentAmount.isGreaterThan(0) || currentAmount.isGreaterThan(maxAmount)) {
                    this.amount = maxAmount.toNumber()
                }
            },
            immediate: true
        }
    },
    methods: {
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        formatCard(card){
            if(!card) return card
            return this.helper.format_card(card)
        },
        ...mapActions(['ActionGetProducts', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang].copied, detail: text, life: 1000 })
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency, 2)
        },
        getBackground(card){
            if(!card || !card.program_id) return '#f0f0f0'
            const cardData = this.cardsTemplate.find(c => c.program_id === card.program_id)
            if(cardData && cardData.background) return cardData.background
            return '#f0f0f0'
        },
        getColor(card){
            if(!card || !card.program_id) return '#000000'
            const cardData = this.cardsTemplate.find(c => c.program_id === card.program_id)
            if(cardData && cardData.color) return cardData.color
            return '#000000'
        },
        getCountry(card){
            if(!card || !card.program_id) return ''
            const cardData = this.cardsTemplate.find(c => c.program_id === card.program_id)
            if(cardData && cardData.country) return cardData.country
            return ''
        },
        toTransactions(){
            this.$router.push(`/personal/card/${this.card_id}/transactions/`)
        },
        async getCard(){
            this.loading = true
            this.cardData = null
            try {
                const cardData = await this.connect.GetUserCardById(this.card_id, this.sensitive).then(res=>res)
                if(cardData.result) this.cardData = cardData.data
                else this.cardData = null
            } catch (error) {
                console.log(error)
            }
            this.loading = false
        },
        async getSensitive(){
            this.sensitive = this.sensitive ? 0 : 1
            this.getCard().then(res=>res)
        },
        getPercentage(value) {
            const amount = new BigNumber(100)
            const comission = amount.multipliedBy(value)
            return comission.toNumber()
        },
        getDebitAmount(value) {
            const amount = new BigNumber(value || 0)
            if (amount.isNaN() || !amount.isGreaterThan(0)) return new BigNumber(0)

            const comission = amount.multipliedBy(this.comissionPercent)
            return amount.plus(comission)
        },
        getCreditAmountByBalance(balance) {
            const bBalance = new BigNumber(balance || 0)
            if (bBalance.isNaN() || !bBalance.isGreaterThan(0)) return new BigNumber(0)

            const multiplier = new BigNumber(1).plus(this.comissionPercent)
            return bBalance.dividedBy(multiplier).decimalPlaces(2, BigNumber.ROUND_FLOOR)
        },
        async topup(){
            this.loading_ = true
            const topupData = {
                card_id: this.card_id,
                amount: this.amount,
            }
            try {
                const topup = await this.connect.TopUpCard(topupData).then(res=>res)
                if(topup.result) {
                    this.displayPopupTopup = false
                    this.getCard(0).then(res=>res)
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Карта скоро будет пополнена', life: 3000 });
                } else {
                    this.showMess('error', 'Ошибка', 'Обратитесь в поддержку')
                    if(topup.errors && topup.errors.length>0) {
                        this.showMess('error', 'Ошибка', topup.errors[0])
                    }
                }
                this.loading_ = false
            } catch (error) {
                console.log(error)
                this.loading_ = false
            }
        },
        roundAmount(val){
            const bAmount = new BigNumber(val)
            if(bAmount.isNaN()) return 0
            const floored = bAmount.decimalPlaces(2, BigNumber.ROUND_FLOOR)
            const decimals = floored.decimalPlaces()
            if(decimals >= 2) return floored.toFixed(2)
            else if(decimals == 1)return floored.toFixed(1)
            else return floored.toFixed(0)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)

        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.card_id = route.params.id
            this.getCard(0).then(res=>res)
        }

        try {
            this.SetHeaderTitle((this.cardData && this.cardData.title) ? this.cardData.title : '')
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: '/personal/vcards/',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                icon: 'pi pi-comments',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>